import { controls } from "../controls";

const exposurelimitagri = {
  label: "Pacs Exposure Limit",
  pageLabel: "Pacs Exposure Limit",
  description: "",
  starting: true,
  url: "exposurelimit",
  formActions: { edit: { allow: true } },
  pageType: "history",
  form: [

    ...controls.displayText({ tab: "create", label: "Parent Branch", width: "col-sm-1" }),
    ...controls.branch({ tab: 'create', isReadOnly: 'edit', isRequired: true, star: true, defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "create", data: "branch_display", name: "branch_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "create", label: "PACS ID", width: "col-sm-1" }),
    ...controls.text({ tab: 'create', isReadOnly: 'edit', name: "pacs_id", isRequired: true, star: true }),

    ...controls.displayText({ tab: "create", label: "Exp Limit", width: "col-sm-1" }),
    ...controls.numberOnly({ tab: "create", name: "exposure_limit", width: "col-sm-2", placeHolder: "Limit" }),

    ...controls.button({
      tab: 'create',
      label: "ADD", style: { padding: 0 },
      Bcolor: "success", onclick: {
        action: "appendToHTMLTable",
        tableNameField: 'exposure_limit_table',
        requiredField: ["branch_code", "branch_display", "pacs_id", "pacs_id_name_display", "exposure_limit"]
      }, width: "col-sm-1"
    }),
    {
      tab: 'create',
      inputType: "table",
      tableTitle: "",
      // convertedTo: "nominee_table",
      deletable: true,
      editable: true,
      // addRows: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "PACS ID", field: "pacs_id" },
        { label: "Name", field: "pacs_id_name_display" },
        { label: "Limit", field: "exposure_limit" }
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "exposure_limit_table"
    }
  ]
};

export default exposurelimitagri;